import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AppConfigService } from '../../Services/app-config.service';
import { Router } from '@angular/router';
import { TopheaderComponent } from '../topheader/topheader.component';
import { BottommenuComponent } from '../bottommenu/bottommenu.component';
import { LocalloopsService } from 'src/app/Services/localloops.service';
import { GoldbarComponent } from '../goldbar/goldbar.component';
import { CruisebiosService } from 'src/app/Services/cruisebios.service';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';


interface localloopInfo {
  StopGrouping: number; 
  ltcName: string; 
  LocalLoopsLocationList: [{
    lllName: string;
    lllDescription: string; 
    lllSortOrder: number; 
    llladdress: string; 
  }]
  LocalLoopsStopTimeList: [{
    StopTime: Date; 
  }]
  BeforeNoon: boolean; 
};

interface ModifiedLoop {
  StopGrouping: number; 
  ltcName: string; 
  LocalLoopsLocationList: [{
    lllName: string;
    lllDescription: string; 
    lllSortOrder: number; 
    llladdress: string; 
  }]
  LocalLoopsStopTimeList: [{
    StopTime: Date; 
  }]
  BeforeNoon: boolean; 

  morningTimes: Date[];
  afternoonTimes: Date[];
  futureTimes: Date[];
  maxLength: Array<any>;
}

type bioInfo = {
  crwName: string;
  crewRole: string;
  crbBioText: string;
  crbBioImageLink: string;
  spcPhoneNumber: string;
  crlOBPortalPhoneDisp: boolean;
  expander: boolean;
};

@Component({
  selector: 'app-localloop-page',
  templateUrl: './localloop-page.component.html',
  styleUrls: ['./localloop-page.component.css'],
  providers: [
    CruisebiosService,
    GoldbarComponent,
    TopheaderComponent,
    BottommenuComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class LocalloopPageComponent implements OnInit, OnDestroy {
  @Input() inputdate: string | undefined;
    
  CurrentDateTime: any;
  userdata?: UserData;

  itiName: any;
  ltcName: string | undefined; 
  itiCode: string | undefined; 
  evtcode: string | undefined;

  private paramsSub?: Subscription; 

  imagepath = '';

  evtCode: string | undefined;

  localloopdata: any;
  localloops: localloopInfo[] = [];

  OBPortalSvcURL = '';

  isLast: boolean | undefined;

  localloopampm: Array<ModifiedLoop> = [];

  cruisebios: bioInfo[] | any;
  cruisebiodata: any;

  click: any;
  validsession: boolean | undefined;

  constructor(
    private router: Router,
    private sesssionvalidator: SessionvalidateService,
    private route: ActivatedRoute,
    private appConfigService: AppConfigService,
    private LocalloopsService: LocalloopsService,
    private CruisebiosService: CruisebiosService,
  ) {
    this.validsession = this.sesssionvalidator.validate();
    if (this.validsession) {
      this.paramsSub = this.route.params.subscribe((params) => {
        this.itiCode = params['itiCode'];
        this.evtcode = this.itiCode;
      });
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy(): void {
    this.paramsSub?.unsubscribe();
  }

ngOnInit(): void {
  this.getLocalLoops(); 
  this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL; 
  this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
  this.evtcode = cruiseContentEvtCodeFromSession(this.userdata);
  this.CurrentDateTime = moment().format('YYYY-MM-DDTHH:mm:ss');
}


getLocalLoops() {
  this.localloopdata = this.LocalloopsService.getLocalLoops(
    this.evtcode
  ).subscribe((localloopdata) => this.setLocalLoops(localloopdata));
}
setLocalLoops(resdata: any) {
  this.localloopdata = resdata; 
  if (this.localloopdata.GetLocalLoops.Result.Status == 'A') {
    this.localloops = this.localloopdata.GetLocalLoops.LocalLoopsList

     this.localloops.forEach((currentValue, index) => {

      const firstLocation = currentValue.LocalLoopsLocationList[0];
      if (this.localloopampm.length === 0 || this.localloopampm[this.localloopampm.length - 1].LocalLoopsLocationList[0].lllName !== firstLocation.lllName) {
        this.localloopampm.push({
          ...currentValue,
          morningTimes: [],
          afternoonTimes: [],
          maxLength: [],
          futureTimes: []
        });
      }

      currentValue.LocalLoopsStopTimeList.forEach(stoptime => {
        // cut off the AM local loop times from the PM local loop times
        let endCutOff = moment(stoptime.StopTime).add(700, 'm');
        let momentForIsBefore = endCutOff.clone().hour(12).minute(0).second(0); 
        let isBeforeNoon = moment(endCutOff).isBefore(momentForIsBefore);

        let CurrentTime = moment();
        let hasPassed = moment(stoptime.StopTime).isBefore(CurrentTime);

        if (isBeforeNoon && !hasPassed) {
          this.localloopampm[this.localloopampm.length - 1].afternoonTimes.push(stoptime.StopTime);
          currentValue.BeforeNoon = true; 
        }
        else if (!hasPassed) {
          this.localloopampm[this.localloopampm.length - 1].morningTimes.push(stoptime.StopTime);
          currentValue.BeforeNoon = false; 
        }
        if (!hasPassed) {
          this.localloopampm[this.localloopampm.length - 1].futureTimes.push(stoptime.StopTime);
        }
     });

      this.localloopampm[this.localloopampm.length - 1].maxLength =
            new Array(Math.max(this.localloopampm[this.localloopampm.length - 1].afternoonTimes.length - 0,
                              this.localloopampm[this.localloopampm.length - 1].morningTimes.length - 0));
        });
     
    this.getCruiseBios();
  }
}

  getCruiseBios() {
    this.cruisebiodata = this.CruisebiosService.getCruiseBios(
      this.evtcode
    ).subscribe((cruisebiodata) => this.setCruiseBios(cruisebiodata));
  }
  setCruiseBios(resdata: any) {
    this.cruisebiodata = resdata;
    if (this.cruisebiodata.GetCruiseBios.Result.Status == 'A') {
      this.cruisebios = this.cruisebiodata.GetCruiseBios.CruiseBiosList;
    }
  }
  
}
